import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
`

export const PasswordIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} width="20" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.667 10.833v-1.27h16.666v1.27H1.668Zm.791-5.291-.833-.459.833-1.416H.833v-.938h1.625l-.833-1.417.833-.458.792 1.396.792-1.396.833.459-.833 1.416h1.625v.938H4.042l.833 1.416-.833.459-.792-1.396-.792 1.396Zm6.75 0-.833-.5.834-1.417H7.584v-.938h1.625l-.834-1.416.834-.458L10 2.208l.792-1.396.833.459-.833 1.417h1.625v.937h-1.625l.833 1.417-.833.5L10 4.146 9.21 5.542Zm6.75 0-.833-.5.834-1.417h-1.625v-.938h1.625l-.834-1.416.834-.458.791 1.395.792-1.396.833.459-.833 1.417h1.625v.937h-1.625l.833 1.417-.833.5-.792-1.396-.791 1.396Z"
        fill="#916EE8"
      />
    </Svg>
  )
}
